<template>
    <popup-modal
        :without-padding="true"
        position="center"
        @close="$emit('close')"
    >
        <div class="w-600">
            <div class="p-32">
                <p class="text-heading-2 font-semibold leading-tight">{{ $t('applications.question_import_title') }}</p>
                <p>{{ $t('applications.question_import_description') }}</p>

                <loading v-if="fetchingQuestions" class="mt-32"></loading>
                <select-dropdown
                    v-else
                    v-model="selectedTemplate"
                    :auto-translate="false"
                    :options="availableTemplates"
                    no-auto-sort
                    class="mt-24 w-full"
                    prefixIcon="sell"
                />
            </div>

            <div class="bg-primary-5 py-20 px-24 flex justify-end space-x-16 rounded-b">
                <simple-button
                    :disabled="addingTemplate"
                    @click="$emit('close')"
                >
                    {{ $t('general.cancel') }}
                </simple-button>
                <simple-button
                    :disabled="selectedTemplate == 0 || addingTemplate"
                    display="secondary"
                    :loading="addingTemplate"
                    look="primary"
                    @click="addTemplateQuestions"
                >
                    {{ $t('general.import') }}
                </simple-button>
            </div>
        </div>
    </popup-modal>

</template>

<script>

import * as templates from '../../services/InterviewTemplateService';
import Interview from '../../models/Interview';
import InterviewTemplate from '../../models/InterviewTemplate';
import {normalizeJson} from '../../../shared/helpers';
import {mapState, mapActions} from 'pinia';
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {useInterviewStore} from '../../state/modules/interviews';
import SelectDropdown from '../forms/SelectDropdown.vue';
import SimpleButton from './SimpleButton.vue';
import PopupModal from './PopupModal.vue';
import Loading from './Loading.vue';
import SvgIcon from './SvgIcon.vue';

export default {
    components: {
        'popup-modal': PopupModal,
        'loading': Loading,
        'select-dropdown': SelectDropdown,
        'simple-button': SimpleButton,
        'svg-icon': SvgIcon,
    },
    props: {
        interview: {
            required: true,
            type: Interview,
        },
        currentQuestions: {
            required: true,
            type: Array,
        },
    },
    data: function () {
        return {
            fetchingQuestions: true,
            selectedTemplate: 0,
            addingTemplate: false,
        };
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        templates() {
            return useRepo(InterviewTemplate)
                .orderBy('order')
                .get();
        },
        availableTemplates() {
            return [
                {
                    value: 0,
                    label: this.$t('general.choose_subject', {subject: this.$t('settings.interview-templates.template')})
                },
                ...this.templates.map(template => ({value: template.id, label: template.titleLocale})),
            ];
        },
    },
    methods: {
        ...mapActions(useInterviewStore, ['setAnswersForTemplateQuestions']),
        async addTemplateQuestions() {
            this.addingTemplate = true;
            let template = this.templates.find((template) => template.id === this.selectedTemplate);

            this.setAnswersForTemplateQuestions({
                interviewId: this.interview.id,
                template
            });
            this.addingTemplate = false;
            this.$emit('close');
        },
    },
    mounted() {
        templates.index(true).then(result => {
            return useRepo(InterviewTemplate).save(normalizeJson(result.data));
        }).then(() => {
            this.fetchingQuestions = false;
        });
    },
};
</script>
